interface AddressComponents {
  city: string;
  street: string;
  house: string;
}

type GeocodeObject = {
  metaDataProperty: {
    GeocoderMetaData: {
      Address: {
        Components: {
          kind: string;
          name: string;
        }[];
      };
    };
  };
};

export const parseAddressFromGeocoder = (geocodeObject: GeocodeObject): AddressComponents => {
  try {
    const addressComponents = geocodeObject.metaDataProperty?.GeocoderMetaData?.Address?.Components;

    const result: AddressComponents = {
      city: '',
      street: '',
      house: '',
    };

    if (!addressComponents) return result;

    for (const component of addressComponents) {
      const kind = component.kind;
      const name = component.name;

      switch (kind) {
        case 'locality':
          result.city = name;
          break;
        case 'street':
          result.street = name;
          break;
        case 'house':
          result.house = name;
          break;
      }
    }

    return result;
  } catch (error) {
    console.error('Ошибка при парсинге адреса:', error);
    return {
      city: '',
      street: '',
      house: '',
    };
  }
};
